import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

function Home() {
  const [phone, setPhone] = useState("");
  const otpRef = useRef([]);
  const [step, setStep] = useState("phone");
  const [mobile, setMobile] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/dashboard");
    }
  }, [navigate]);

  const handleInputChange = (e, index, refs, maxLength = 1) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value) {
      e.target.value = value.slice(0, maxLength);
      if (index < refs.current.length - 1) {
        refs.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (e, index, refs) => {
    if (e.key === "Backspace" && !e.target.value && index > 0) {
      refs.current[index - 1].focus();
    }
  };

  const handlePaste = (e, refs, maxLength) => {
    e.preventDefault();
    const paste = e.clipboardData
      .getData("text")
      .replace(/\D/g, "")
      .slice(0, maxLength);
    paste.split("").forEach((char, i) => {
      refs.current[i].value = char;
    });
    const nextInput = refs.current[paste.length];
    if (nextInput) nextInput.focus();
  };

  const getCombinedValue = (refs) =>
    refs.current.map((input) => input.value).join("");

  const handlePhoneSubmit = async (e) => {
    e.preventDefault();
    if (phone.length !== 10) {
      alert("Please enter a valid 10-digit phone number.");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(
        "https://xqk5c9abna.execute-api.ap-south-1.amazonaws.com/prod/auth/Login",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ mobile: Number(phone), role: "admin" }),
        }
      );

      if (!res.ok) throw new Error("Login failed");

      setMobile(phone);
      setStep("otp");
    } catch (err) {
      console.error(err);
      alert("Failed to send OTP.");
    } finally {
      setLoading(false);
    }
  };

  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    const otp = getCombinedValue(otpRef);
    if (otp.length !== 4) {
      alert("Enter the full 4-digit OTP.");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(
        "https://xqk5c9abna.execute-api.ap-south-1.amazonaws.com/prod/auth/VerifyOtp",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ mobile: Number(mobile), otp: Number(otp) }),
        }
      );

      if (!res.ok) throw new Error("OTP verification failed");

      const data = await res.json();
      localStorage.setItem("token", data.token);
      navigate("/dashboard");
    } catch (err) {
      console.error(err);
      alert("Invalid OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="container d-flex flex-column vh-100">
      <div className="row align-items-center justify-content-center g-0 h-lg-100 py-8">
        <div className="col-lg-5 col-md-8 py-8 py-xl-0">
          <div className="bg-light rounded-5">
            <div className="card-body p-6 d-flex flex-column gap-4">
              <div>
                <img
                  src="/assets/images/logo-red.png"
                  width="120"
                  className="mb-2"
                  alt="logo-icon"
                />
                <h2 className="mb-0 fw-bold lh-1">
                  {step === "phone" ? "Administrator Login" : "Verify OTP"}
                </h2>
                <span className="m-0">
                  {step === "phone"
                    ? "Enter Phone Number to Continue"
                    : `Enter the OTP sent to ${mobile}`}
                </span>
              </div>

              {step === "phone" && (
                <form onSubmit={handlePhoneSubmit}>
                  <div className="mb-3 col-lg-8 col-12">
                    <label className="form-label">Phone Number</label>
                    <input
                      type="text"
                      placeholder="Enter Phone No"
                      className="form-control"
                      maxLength="10"
                      value={phone}
                      onChange={(e) =>
                        setPhone(e.target.value.replace(/\D/g, ""))
                      }
                    />
                    <div className="m-0 mt-1">Enter 10-digit phone number</div>
                  </div>
                  {step === "phone" && (
                    <button
                      className="btn btn-primary px-8 mt-2"
                      type="submit"
                      disabled={loading}
                    >
                      {loading ? "Sending OTP" : "Send OTP"}
                    </button>
                  )}
                </form>
              )}

              {step === "otp" && (
                <form onSubmit={handleOtpSubmit}>
                  <div className="mb-3">
                    <label className="form-label">OTP</label>
                    <div
                      className="d-flex gap-1"
                      onPaste={(e) => handlePaste(e, otpRef, 4)}
                    >
                      {[...Array(4)].map((_, i) => (
                        <input
                          key={i}
                          type="text"
                          maxLength="1"
                          ref={(el) => (otpRef.current[i] = el)}
                          onChange={(e) => handleInputChange(e, i, otpRef)}
                          onKeyDown={(e) => handleKeyDown(e, i, otpRef)}
                          className="form-control text-center p-1 fw-bold text-black"
                          style={{ width: "2.5rem", fontSize: "1.25rem" }}
                        />
                      ))}
                    </div>
                    <div className="m-0 mt-1">Enter the 4-digit OTP</div>
                  </div>
                  {step === "otp" && (
                    <button
                      className="btn btn-success px-8 mt-2"
                      type="submit"
                      disabled={loading}
                    >
                      {loading ? "Verifying OTP" : "Verify OTP"}
                    </button>
                  )}
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Home;
